function MainConfigurationViewController(
  userViewService,
  trainService,
  eventService,
  userService,
  CommonService,
  $stateParams,
  $state,
  $scope,
  $location,
  __env
) {
  const ctrl = this;
  const env = __env;

  ctrl.$onInit = () => {
    userViewService.setView('configuration');
    CommonService.setConsist($stateParams.consist);
    ctrl.consist = $stateParams.consist;
    ctrl.train = null;
    ctrl.loadTrain();
    ctrl.eventListener();
    ctrl.lastLoad = DateTime.now();
    ctrl.hasProfile = env.profile !== 'QR'; // Naming this way to hide project names from HTML
    ctrl.hasAccessOTOOL = userService.hasAccessOTOOL() && env.profile !== 'MELCO';
    ctrl.hasTrainManagement = userService.hasTrainManagement() && env.profile !== 'MELCO'; // Train management disabled for MELCO until Phase III-B
    ctrl.hasTrainNetwork = userService.hasTrainNetwork();
    ctrl.hasDrivers = userService.hasAccessDriversView() && env.profile !== 'MELCO' && env.operator !== 'bakerloo';
    ctrl.hasSoftwareStatus = ctrl.hasTrainManagement && (env.profile === 'LU' || env.profile === 'DEMO');

    let prevView = userViewService.getPreviousView();
    if (prevView === 'dashboard' || prevView === 'dashboard2') {
      userViewService.setPreviousDashboard(prevView);
    }
  };

  ctrl.eventListener = () => {
    const unbind = eventService.on('FLEET_STATUS', function() {
      if (ctrl.lastLoad.diffNow('seconds').seconds < -3) {
        ctrl.loadTrain();
        ctrl.lastLoad = DateTime.now();
      }
    });
    $scope.$on('$destroy', unbind);
  };

  ctrl.loadTrain = function() {
    trainService
      .get(ctrl.consist)
      .then(function(data) {
        if (!data) {
          ctrl.connectionStatusToTrain = false;
        } else {
          ctrl.connectionStatusToTrain = true;
          if (!angular.equals(ctrl.train, data)) {
            ctrl.train = data;
            ctrl.lastLoad = DateTime.now();
          }
          data = null;
        }
      })
      .catch(error => {
        console.log('Error: ' + error);
      });
  };

  ctrl.goToSoftwareStatus = () => {
    $state.go('train.swstatus', { });
  }

  ctrl.goToTrainManagement = () => {
    // by default go to first car
    let carNum =  ctrl.train.carActiveEventStatuses[0].carNumber
    ctrl.isOnTrainManagement();
    $state.go('train.management', { carNumber: carNum, trainId: ctrl.train.status.trainId });
  }

  ctrl.isOnTrainManagement = () => {
    let url = $location.absUrl();
    return (url.includes('/train') && url.includes('/management'));
  }

  ctrl.isOnSoftwareStatus = () => {
    let url = $location.absUrl();
    return (url.includes('/sw-status'));
  }

  ctrl.goBack = () => {
    if (userViewService.getPreviousDashboard()) {
      CommonService.setSelectedTrain(null);
      $state.go(userViewService.getPreviousDashboard());
    } 
  };
}

angular
  .module('configuration-management.module')
  .controller('MainConfigurationViewController', MainConfigurationViewController);
